import { render, staticRenderFns } from "./SlideshowTabPanel.vue?vue&type=template&id=0bf2f1f2&"
import script from "./SlideshowTabPanel.vue?vue&type=script&lang=js&"
export * from "./SlideshowTabPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports